import { CountryCode, SpatialAggregationType } from "./common";
import { AdminAreaSettings } from "./spatial";

export enum PoiLevel {
  GROUP = "group",
  CATEGORY = "category",
  BRAND = "brand"
}

export interface PoiParameterResponse {
  data: PoiIndustry[];
}

export interface PoiIndustry {
  code: string;
  created_at: string;
  updated_at: string;
  icon_url: string | null;
  name: string;
  poi_groups: PoiGroup[] | null;
}

export interface PoiGroup {
  code: string;
  created_at: string;
  updated_at: string;
  icon_url: string | null;
  name: string;
  poi_industry_code: string;
  poi_categories: PoiCategory[] | null;
}

export interface PoiCategory {
  code: string;
  created_at: string;
  updated_at: string;
  icon_url: string | null;
  name: string;
  poi_group_code: string;
  poi_brands?: PoiBrandSearch[]; // optional, only populated when fetching brands by category
}

export interface PoiBrandSearch {
  type: PoiLevel;
  brand_name: string;
  brand_code: string;
  category_name: string;
  category_code: string;
  group_name: string;
  group_code: string;
  industry_name: string;
  industry_code: string;
}

export interface PoiBrandCategoryGroup {
  categoryCode: string;
  categoryName: string;
  brands: PoiBrandSearch[];
}

export type PoiBrandGroupedByCategory = Record<string, PoiBrandCategoryGroup>;

export interface PoiSearchPayload {
  query?: string;
  page?: number;
  perPage?: number;
}

export interface PoiBrandSearchPayload extends PoiSearchPayload {
  categoryCode?: string;
  countryId?: string;
}

export interface PoiSearchResponse {
  data: PoiBrandSearch[];
  meta: {
    pagination: {
      next: number;
      prev: number;
      total: number;
      total_pages: number;
      per_page: number;
    };
  };
}

export type BrandAction = "add" | "remove";

export interface PostPoiParametersPayload {
  country_id: string;
  industry_codes: string[];
  group_codes: string[];
  category_codes: string[];
  brand_codes: string[];
  adm_area_codes: string[];
}

export interface DatasetFilterPoiParameter {
  schema_id: string;
  filters: string[];
}

export interface DatasetPoiParameter {
  dataset_id: string;
  dataset_name: string;
  filters: DatasetFilterPoiParameter[];
  is_subscribed: boolean;
  spatial_aggregation_type: SpatialAggregationType;
  parent_id: string | null;
}

export interface PostPoiParametersResponse {
  datasets: DatasetPoiParameter[];
  message: string | null;
}

export interface PoiParameterState {
  selectedCountry: { label: string; value: CountryCode } | null;
  selectedAdminArea: AdminAreaSettings | null;
  selectedAdminAreaIds: string[];
  activeIndustry: string;
  activeGroup: string;
  selectedBrands: PoiBrandGroupedByCategory;
  selectedCategories: Set<string>;
  expandedCategories: Set<string>;
  sidebarExpandedCategories: { [categoryCode: string]: boolean };
  poiPayload: PostPoiParametersPayload | null;
  selectedDatasetId: string | null;
  selectedDatasetIds: string[];
}
